import React from 'react';
import ReactDOM from 'react-dom/client';
import {QueryClient,QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import './styles.css';

const queryClient=new QueryClient({defaultOptions:{queries:{staleTime:3000,retry:1,refetchOnWindowFocus:false}}});
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><ConfigProvider locale={zhCN} theme={{token:{colorPrimary:'#146c43',borderRadius:10,fontFamily:'Inter, "Noto Sans SC", sans-serif'}}}><QueryClientProvider client={queryClient}><BrowserRouter basename="/app"><App/></BrowserRouter></QueryClientProvider></ConfigProvider></React.StrictMode>);
